module.exports = __webpack_public_path__ + "assets/img/pt-ddfda3b8.png";